// extracted by mini-css-extract-plugin
export var content = "textButtonImgBgSection-module--content--c00b7";
export var image = "textButtonImgBgSection-module--image--6fd34";
export var imageDesktop = "textButtonImgBgSection-module--imageDesktop--c6cb0";
export var overlay = "textButtonImgBgSection-module--overlay--1b355";
export var text = "textButtonImgBgSection-module--text--6296b";
export var wrapper = "textButtonImgBgSection-module--wrapper--521d8";